export const getDurationText = (duration, months) => {
    if (duration === 'repeating') return `${months} mois`;
    if (duration === 'forever') return 'Permanent';
    return 'Une fois';
}